import React from 'react';

export default function TheMath({ lang }) {
  return (
    <section className="w-full py-12">
      <h2 className="text-4xl sm:text-5xl font-black uppercase mb-8 border-b-8 border-amber-400 pb-2 inline-block">
        {lang === 'en' ? 'The Math' : 'Las Matemáticas'}
      </h2>
      
      <div className="bg-amber-400 text-black p-6 border-4 border-white shadow-[8px_8px_0_0_#ffffff] transform rotate-1">
        <ul className="text-2xl sm:text-3xl font-black flex flex-col gap-4 uppercase">
          <li className="flex justify-between border-b-4 border-black pb-2">
            <span>{lang === 'en' ? '10 Beers' : '10 Cervezas'}</span>
            <span>30€+</span>
          </li>
          <li className="flex justify-between border-b-4 border-black pb-2 text-white bg-black px-2 -mx-2">
            <span>{lang === 'en' ? 'You Pay' : 'Tú Pagas'}</span>
            <span>15 €</span>
          </li>
          <li className="flex justify-between pt-2 text-3xl sm:text-4xl">
            <span>{lang === 'en' ? 'You Save' : 'Ahorras'}</span>
            <span>15 €+</span>
          </li>
        </ul>
      </div>
    </section>
  );
}